<div class="step">
    <div class="container step__container" v-if="!mortgageDataLoaded">
        <div class="card step__card" style="margin:0;">
            <div class="step__titleWrap scrollAnimation scrollAnimation--active" style="margin-bottom:27px;">
                <div class="step__title">التحقق من وثيقة رهن أعيان</div>
            </div>

            <div class="step__cardBody">
                <div>خدمة تساعدك على التحقق من صحة وثيقة الرهن الصادرة من وزارة العدل</div>
                <div class="mt-1 mb-2 text-muted" style="font-size:14px;">
                    علامة <span style="color:red;">*</span> تعني أن الحقول مطلوبة
                </div>

                <!-- رقم وثيقة الرهن -->
                <div class="step__inputWrap input scrollAnimation scrollAnimation--active">
                    <div class="step__inputLabel input__label">
                        <label for="mortgagesNo" class="Required">رقم وثيقة الرهن</label>
                    </div>
                    <input id="mortgagesNo"
                           class="step__inputField input__field"
                           placeholder="رقم وثيقة الرهن"
                           v-model="mortgagesNo"
                           v-mask="'###############'"
                           maxlength="20"
                           required />
                </div>

                <div class="step__question scrollAnimation scrollAnimation--active"></div>

                <!-- تاريخ إصدار الوثيقة -->
                <div class="step__inputWrap input scrollAnimation scrollAnimation--active">
                    <div class="step__inputLabel input__label">
                        <label for="dateInput" class="Required">تاريخ إصدار الوثيقة</label>
                    </div>

                    <input id="dateInput"
                           type="text"
                           v-model="issueDate"
                           class="step__inputField input__field"
                           placeholder="تاريخ إصدار الوثيقة" />
                    <date-picker v-model="issueDate"
                                 :locale="'ar-sa'"
                                 :calendar="'hijri'"
                                 element="dateInput"
                                 :wrapper-submit="true"
                                 appendTo=".container"
                                 :auto-submit="true"
                                 format="iYYYY-iMM-iDD"
                                 display-format="dddd iDD iMMMM iYYYY"
                                 color="#158e8d">
                    </date-picker>
                </div>

                <div class="step__question scrollAnimation scrollAnimation--active"></div>

                <!-- رقم هوية المتحقق (للمستخدم المجهول فقط) -->
                <div class="step__inputWrap input scrollAnimation scrollAnimation--active"
                     v-if="!isDataLoading && isAnnoymousUser">
                    <div class="step__inputLabel input__label">
                        <label for="userlId" class="Required">رقم هوية المتحقق</label>
                    </div>
                    <input id="userlId"
                           class="step__inputField input__field"
                           placeholder="رقم هوية المتحقق"
                           v-model="userlId"
                           v-mask="'##########'"
                           maxlength="10"
                           required />
                </div>

                <div class="step__question scrollAnimation scrollAnimation--active"></div>

                <!-- recaptcha -->
                <div class="step__recaptcha scrollAnimation scrollAnimation--active">
                    <Recaptcha id="recaptchaVerify"
                               :sitekey="siteKey"
                               :verify="onVerifyRecaptcha"
                               v-if="isRecaptchaEnabled"
                               :expired="onExpiredRecaptcha"
                               ref="reCaptcha"
                               :class="{not_valid: !isReCaptchaTokenValid}">
                    </Recaptcha>
                </div>

                <div class="step__question scrollAnimation scrollAnimation--active"></div>

                <!-- submit -->
                <button id="btnSubmit"
                        class="button button--gold"
                        :disabled="disableSubmitButton"
                        @click="verifyDataWithOTP">
                    <span class="button__buttonText">تحقق</span>
                    <span class="button__buttonIcon icon icon-arrow_right"></span>
                </button>
            </div>
        </div>
    </div>

    <!-- ========== Document view ========== -->
    <div v-if="mortgageDataLoaded">
        <surveyview :HeaderText="QaimHeader"
                    :FooterText="QaimFooter"
                    :SurveyID="QaimSurveyID"
                    :FirstName="QaimFirstName"
                    :LastName="QaimLastName"
                    :BirthDate="QaimBirthDate"
                    :NationalityNumber="QaimNationalityNumber"
                    :NationalityId="QaimNationalityId"
                    :Gender="QaimusrGender"
                    Lang="ar"
                    :Config="QaimConfig"
                    :RefNum="mortgagesNoWithReference"
                    v-if="openRating">
            <template v-slot:header>
                <div class="custom-header-container">
                    <div class="Popup__checkMark" style="border: 2px solid; padding: 40px;">
                        <span class="icon icon-check"></span>
                    </div>
                    <span v-html="QaimHeader"></span>
                    <div class="seperator"></div>
                </div>
            </template>
            <!-- @OnSurveyClosed="CloseQaimEvent(QaimresponseSentToUrl)" -->
        </surveyview>

        <div class="row">
            <div class="col-md-8 m-auto">
                <div class="text-center mt-4" v-if="!isMobileView">
                    <button type="button" class="btn btn-primary text-white" @click.prevent="PrintReport">حفظ الوثيقة</button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8 m-auto">
                <div class="text-left my-4" v-if="isMobileView">
                    <button type="button" class="btn btn-primary text-white px-5" @click.prevent="PrintReport">حفظ الوثيقة</button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8 m-auto">
                <vue-pdf-app :config="pdfConfig"
                             @pages-rendered="pdfPagesRendered"
                             @after-created="pdfOpened"
                             style="height: 100vh;"
                             :pdf="docUrl">
                </vue-pdf-app>
            </div>
        </div>
    </div>

    <!-- ========== Single dialog: Nafath OR OTP ========== -->
    <v-dialog class="dialog-class" v-model="showOTPDialog" max-width="500">
        <v-card height="auto">
            <!-- Title -->
            <v-card-title class="justify-center">
                <div v-if="showNafathDiv">تأكيد الهوية عبر النفاذ الوطني</div>
                <div v-else>أدخل رمز التحقق</div>

                <!--<div style="position: absolute; left: 15px; top: 10px;">
                    <button @click="closeOTPDialog"><v-icon>mdi-close</v-icon></button>
                </div>-->
            </v-card-title>

            <div class="profile__container profile__container--floatingBox mt-0">
                <!-- ===== NAFATH MODE ===== -->
                <div v-if="showNafathDiv" style="text-align:center; padding: 18px;">
                    <p v-if="!nafathErrorMessage" style="font-weight: bold; color: #158e8d; font-size: 18px; margin-bottom: 12px;">
                        الرجاء فتح تطبيق نفاذ وتأكيد الطلب باختيار الرقم الظاهر
                    </p>
                    <p v-else style="font-weight: bold; color: red; font-size: 16px; margin-bottom: 12px;">
                        {{ nafathErrorMessage }}
                    </p>

                    <div v-if="!nafathErrorMessage"
                         style="display: inline-block; background-color: #158e8d; padding: 18px 36px; border-radius: 16px; margin: 12px 0;">
                        <span style="font-size: 3rem; color: white;">{{ nafathCode }}</span>
                    </div>

                    <v-card-actions style="justify-content:center; gap: 12px;">
                        <!--<button class="button button--radius button--gold" :disabled="disableResend" @click="resendOTP">
                            <span class="button__buttonText">إعادة إرسال الطلب</span>
                        </button>-->

                        <button style="background:none; border:none; color:red; font-size:16px; cursor:pointer;"
                                @click="cancelNafath">
                            إلغاء
                        </button>
                    </v-card-actions>
                </div>

                <!-- ===== OTP MODE ===== -->
                <div v-else>
                    <div class="row">
                        <p>{{$t('mortgages.mortgage.EnterOTP')}}<br /></p>

                        <div class="col-md-12 text-center" v-if="timeToExpire !== '0'">
                            <small class="form-text text-muted text-center">
                                {{$t('mortgages.mortgage.expireTime')}}<br /><br />
                                {{ timeToExpire }}
                            </small>
                        </div>

                        <div class="col-md-12 text-center">
                            <input type="text"
                                   ref="txtOtpCode"
                                   v-model="otpCode"
                                   maxlength="6"
                                   v-mask="'######'"
                                   class="form-control text-center" />
                        </div>
                    </div>

                    <v-card-actions>
                        <div class="profile__buttons m-auto pt-3 text-center">
                            <button class="button button--radius button--gold" @click="resendOTP" :disabled="disableResend">
                                <span class="button__buttonText">إعادة إرسال</span>
                            </button>

                            <button class="button button--radius button--gold mx-4" style="background-color: #158e8d;" @click="VerifyOTP">
                                <span class="button__buttonText">تحقق</span>
                            </button>
                        </div>
                    </v-card-actions>
                </div>
            </div>
        </v-card>
    </v-dialog>
</div>
